
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/contact",
      function () {
        return require("private-next-pages/qmee/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/contact"])
      });
    }
  